import React, {FC, useEffect} from "react";
import {useBreadcrumb} from "../../hooks/useBreadcrumb";

interface IProps {
    children: any,
}

const ContextJsx: FC<IProps> = ({children}) => {
    const { setBreadcrumbComponent } = useBreadcrumb();

    useEffect(() => {
        React.Children.map(children, (child, index) => {
            if (child.type?.displayName === 'Breadcrumb') {
                setBreadcrumbComponent({
                    component: child
                });
            }
        })
    }, [children]);

    if (typeof children === 'object' && children.length) {
        return children.filter((child) => {
            if (child.type?.displayName !== 'Breadcrumb') {
                return true
            }
        })
    }
    else if (typeof children === 'object' && children.type?.displayName === 'Breadcrumb') {
        return null;
    }
    else {
        return children;
    }
}

export default React.memo(ContextJsx);
